import {
    camelCase, capitalize, endsWith, escape, kebabCase, pad, replace, snakeCase, startsWith, trim, trimEnd,
    trimStart
} from 'lodash';

export {
    camelCase, capitalize, endsWith, escape, kebabCase, pad, replace, snakeCase, startsWith, trim, trimEnd,
    trimStart
} from 'lodash';

export function isEmpty(value) {
    return (value === null) || (value === '');
}

export function isNotEmpty(value) {
    return !isEmpty(value);
}

export function isBlank(value) {
    return isEmpty(trimToEmpty(value));
}

export function isNotBlank(value) {
    return !isBlank(value);
}

export function trimToEmpty(value) {
    return (value === null) ? '' : trim(value);
}

export function isANumber(testSting) {
    return testSting.match(/^[0-9]+$/);
}
export function isNotANumber(value) {
    return !isANumber(value);
}


export function replaceStartAndEndStrings(originalStr, strToReplace, replacementStr) {
    var str = originalStr;
    if (startsWith(str), strToReplace) {
        str = replace(str, strToReplace, replacementStr);
    }
    //previous statement only replaces first instance
    if (endsWith(str), strToReplace) {
        str = replace(str, strToReplace, replacementStr);
    }
    return str;
}

export default {
    camelCase,
    capitalize,
    escape,
    kebabCase,
    pad,
    snakeCase,
    trim,
    trimEnd,
    trimStart,
    isEmpty,
    isNotEmpty,
    isBlank,
    isNotBlank,
    trimToEmpty,
    replace,
    endsWith,
    startsWith,
    isNotANumber,
    isANumber
};
